module.exports = __webpack_public_path__ + "img/hero-about.c31572f6.jpg";